import React from 'react';
import PropTypes from 'prop-types';
import PriceLine from './PriceLine';
import { Typography } from '@material-ui/core';
import { toPrice } from '~/utils/format';

function PriceLineGroup(props) {
  const { groupName, groupItems } = props;

  if (!groupName || !groupItems) {
    return null;
  }

  const totalAmount = groupItems.reduce((acc, item) => {
    acc = acc + parseFloat(item.amount);
    return acc;
  }, 0);

  const amount = {
    amount: totalAmount.toString(),
    name: groupName,
    customerDisplayName: groupName,
    customerDescription: (
      <>
        {groupItems.map((amount) => (
          <React.Fragment key={amount.name}>
            <Typography variant='subtitle1'>
              {amount.customerDisplayName} {toPrice(amount.amount)}
            </Typography>
            {amount.customerDescription && (
              <Typography variant='caption' color='textSecondary'>
                {amount.customerDescription}
              </Typography>
            )}
          </React.Fragment>
        ))}
      </>
    ),
    customerDisplayGroup: null,
  };

  return <PriceLine amount={amount} />;
}

export default PriceLineGroup;

PriceLineGroup.propTypes = {
  groupName: PropTypes.string,
  groupItems: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.string.isRequired,
      customerDescription: PropTypes.string,
      customerDisplayName: PropTypes.string.isRequired,
      customerDisplayGroup: PropTypes.string,
      name: PropTypes.string.isRequired,
    })
  ),
};
